/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconHttpDelete = createReactComponent("outline", "http-delete", "IconHttpDelete", [["path", { "d": "M3 8v8h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-2z", "key": "svg-0" }], ["path", { "d": "M14 8h-4v8h4", "key": "svg-1" }], ["path", { "d": "M10 12h2.5", "key": "svg-2" }], ["path", { "d": "M17 8v8h4", "key": "svg-3" }]]);

export { IconHttpDelete as default };
//# sourceMappingURL=IconHttpDelete.mjs.map
